import { useState } from 'react';
import { supabase } from '../../lib/supabase';

interface DeleteCaseProps {
  caseId: string;
  onSuccess?: () => void;
}

export function DeleteCase({ caseId, onSuccess }: DeleteCaseProps) {
  const [isConfirming, setIsConfirming] = useState(false);
  
  const handleDelete = async () => {
    if (!isConfirming) {
      setIsConfirming(true);
      return;
    }
    
    try {
      // Delete the case from the database
      const { error } = await supabase
        .from('cases')
        .delete()
        .eq('id', caseId);
        
      if (error) throw error;
      
      if (onSuccess) {
        onSuccess();
      }
      
      setIsConfirming(false);
    } catch (error) {
      console.error('Error deleting case:', error);
      setIsConfirming(false);
    }
  };
  
  const handleCancel = () => {
    setIsConfirming(false);
  };

  return (
    <>
      {isConfirming ? (
        <div className="flex items-center gap-2">
          <button 
            onClick={handleDelete}
            className="flex items-center gap-1 text-red-600 hover:text-red-800 px-2 py-1 rounded-md hover:bg-red-50"
          >
            <span>Confirm</span>
          </button>
          <button 
            onClick={handleCancel}
            className="flex items-center gap-1 text-gray-600 hover:text-gray-800 px-2 py-1 rounded-md hover:bg-gray-50"
          >
            <span>Cancel</span>
          </button>
        </div>
      ) : (
        <button 
          onClick={handleDelete}
          className="flex items-center gap-1 text-red-600 hover:text-red-800 px-2 py-1 rounded-md hover:bg-red-50"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
          </svg>
          <span>Delete</span>
        </button>
      )}
    </>
  );
}
